 $('.sub--heading.question').click(function(){
    $(this).toggleClass('dev_angleDown');
    $(this).next('.answer').slideToggle();
    $(this).parent().siblings().find('.answer').slideUp();
    $(this).parent().siblings().find('.question').removeClass('dev_angleDown');
  });
  
  $('.dev_faqItem').click(function(e){
    e.preventDefault();
    $(this).addClass('dev_activeBlock');
    $(this).siblings('li').removeClass('dev_activeBlock');
    $('.Devspaced-section').hide();
    $('.textdescriptionclass .dev_faqsPage').slideToggle();
  });
  
  $('.dev_orderItem').click(function(e){
    e.preventDefault();
    $(this).addClass('dev_activeBlock');
    $(this).siblings('li').removeClass('dev_activeBlock');
    $('.Devspaced-section').hide();
    $('.dev_ordersPage').show();
  });
  
  $('.dev_returnItem').click(function(e){
    e.preventDefault();
    $(this).addClass('dev_activeBlock');
    $(this).siblings('li').removeClass('dev_activeBlock');
    $('.Devspaced-section').hide();
    $('.dev_returnsPage').show();
  });
  
  $('.dev_contactItem').click(function(e){
    e.preventDefault();
    $(this).addClass('dev_activeBlock');
    $(this).siblings('li').removeClass('dev_activeBlock');
    $('.Devspaced-section').hide();
    $('.dev_contactPage').show();
  });
  
  $('.dev_deliveryItem').click(function(e){
    e.preventDefault();
    $(this).addClass('dev_activeBlock');
    $(this).siblings('li').removeClass('dev_activeBlock');
    $('.Devspaced-section').hide();
    $('.dev_deliveryPage').show();
  });
  
  
  $('.dev_desktopLayout .dev_faqItem').trigger('click');
  
  $('.faqmenumobileitem li').click(function(e){
    e.preventDefault();
    $(this).addClass('dev_activeBlock');
    $(this).siblings('li').removeClass('dev_activeBlock');    
    $(this).next('.Devspaced-section').slideToggle();
    $(this).siblings('li').next('.Devspaced-section').hide();
  });


$('.cl-delivery-country').on('change', function(){
  console.log($(this).val());
  var thisVal = $(this).val();
  $('.dev_countryContent').each(function(){
    var CountryName = $(this).attr('data-country');
    if(CountryName == thisVal){
      $(this).show();
      $(this).siblings('.dev_countryContent').hide();
    }
  });
});

$('.cl-delivery-country').val('United Kingdom').change();